/* Noiressence — « Installer l'appli » (PWA). Même réglage qu'APV Pharma (20/10/2026). Chargé sur toutes les pages.
   - Dans l'appli installée (affichage « standalone ») : rien n'est montré.
   - Quand le navigateur propose l'installation (beforeinstallprompt : Chrome, Edge, Samsung Internet…), nos boutons
     ouvrent directement sa fenêtre « Installer ». L'événement a pu arriver avant ce script : layout/theme.liquid le
     range dans window.NX_INVITE.
   - Sinon, ils ouvrent le guide (#nxAppliGuide) adapté à l'appareil : Android, iPhone, navigateur intégré à une appli
     (Facebook, Messenger, Instagram… : ouvrir d'abord dans Chrome ou Safari), ordinateur.
   - Les boutons restent toujours visibles dans le navigateur : après un refus, Chrome ne repropose plus sa fenêtre
     pendant des semaines, mais le guide (menu ⋮ › Installer) marche toujours.
   - Carte d'invitation (#nxAppliCarte) : téléphone seulement, sur l'accueil, les collections, la recherche et les pages
     d'infos, après 8 s (1,5 s dès la 2e page de la visite) ; « Plus tard » la cache 7 jours, un refus 3 jours ; pas
     après une installation, SAUF si le navigateur repropose l'installation (appli supprimée) : la carte revient alors.
   - Lien noiressence.ci/?appli (à partager) : remet à zéro « Plus tard » et le refus, une seule fois par onglet, et
     montre la carte tout de suite sur téléphone (sauf sur la fiche produit et le panier).
   Rien n'est envoyé nulle part : seuls des repères locaux (localStorage / sessionStorage) sont gardés. */
(() => {
  "use strict";
  const D = document, racine = D.documentElement;
  const vu = (q) => window.matchMedia && matchMedia(q).matches;
  const enAppli = () => vu("(display-mode: standalone)") || vu("(display-mode: fullscreen)") || vu("(display-mode: minimal-ui)") || navigator.standalone === true;
  if (enAppli()) {
    racine.classList.add("nx-en-appli");
    return;
  }

  const ua = navigator.userAgent || "";
  const ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const android = /Android/i.test(ua);
  // navigateurs intégrés aux applis (Facebook, Messenger, Instagram, TikTok… et WebView Android) : pas d'installation
  const integre = /FBAN|FBAV|FB_IAB|FBIOS|FB4A|Instagram|Messenger|musical_ly|TikTok|Snapchat|Line\/|Twitter/i.test(ua) || (android && /; wv\)/.test(ua));
  const telephone = () => vu("(max-width: 749px)");

  const CLE_PLUS_TARD = "nx-appli-plus-tard", CLE_REFUS = "nx-appli-refus", CLE_INSTALLEE = "nx-appli-installee";
  const CLE_VUES = "nx-appli-vues", CLE_LIEN = "nx-appli-lien";
  // l'accès même à localStorage peut lever une erreur (cookies bloqués) : tout passe par le try
  const lire = (n, k) => { try { return window[n].getItem(k); } catch (_) { return null; } };
  const ecrire = (n, k, v) => { try { window[n].setItem(k, v); } catch (_) { /* sans mémoire */ } };
  const effacer = (n, k) => { try { window[n].removeItem(k); } catch (_) { /* sans mémoire */ } };
  const recent = (k, jours) => Date.now() - (Number(lire("localStorage", k)) || 0) < jours * 864e5;
  // ancien repère de la 1re version (bandeau caché 30 jours, même après une installation) : abandonné
  effacer("localStorage", "nx-appli-ferme");

  const zone = D.getElementById("nxAppli");
  const dlg = D.getElementById("nxAppliGuide");
  const carte = D.getElementById("nxAppliCarte");
  let invite = window.NX_INVITE || null;   // beforeinstallprompt gardé pour nos boutons (la mini-barre de Chrome est remplacée par notre carte)
  let minuteur = 0, enCours = false;

  /* ------------------------------------------------------------ boutons « Installer l'application » */
  const boutons = (oui) => D.querySelectorAll("[data-nx-installer]").forEach((b) => { b.hidden = !oui; });
  const devenueAppli = () => {   // installée : l'onglet d'ordinateur passe dans la fenêtre de l'appli, sans recharger
    invite = window.NX_INVITE = null;
    clearTimeout(minuteur);
    minuteur = 0;
    fermerCarte();
    fermerGuide();
    boutons(false);
  };
  // lien partagé « ?appli » : traité une seule fois par onglet, pour qu'un rechargement ne revienne pas sur un
  // « Plus tard » ; le repère « installée » n'est jamais effacé ici (seul le navigateur le fait, quand il propose
  // vraiment l'installation)
  const parLien = /[?&]appli(=|&|$)/.test(location.search) && !lire("sessionStorage", CLE_LIEN);
  if (parLien) {
    ecrire("sessionStorage", CLE_LIEN, "1");
    [CLE_PLUS_TARD, CLE_REFUS].forEach((k) => effacer("localStorage", k));
  }
  if (invite) effacer("localStorage", CLE_INSTALLEE);   // le navigateur propose l'installation : l'appli n'est pas (ou plus) là
  boutons(true);   // toujours visibles dans le navigateur : le guide marche même quand Chrome ne propose plus sa fenêtre

  addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    invite = window.NX_INVITE = e;
    effacer("localStorage", CLE_INSTALLEE);   // appli supprimée depuis : la carte peut revenir
    boutons(true);
    planifierCarte(1500);
  });
  addEventListener("appinstalled", () => {
    ecrire("localStorage", CLE_INSTALLEE, String(Date.now()));
    devenueAppli();
  });
  const mq = window.matchMedia ? matchMedia("(display-mode: standalone)") : null;
  const surMode = (e) => { if (e.matches) { racine.classList.add("nx-en-appli"); devenueAppli(); } };
  if (mq) { if (mq.addEventListener) mq.addEventListener("change", surMode); else if (mq.addListener) mq.addListener(surMode); }

  /* ------------------------------------------------------------ guide */
  const cas = () => (integre ? "integre" : ios ? "ios" : android ? "android" : telephone() ? "android" : "ordi");
  const ouvrirGuide = () => {
    if (!dlg) return;
    const c = cas();
    dlg.querySelectorAll("[data-nx-cas]").forEach((bloc) => { bloc.hidden = bloc.getAttribute("data-nx-cas") !== c; });
    const chrome = dlg.querySelector("[data-nx-chrome]");
    if (chrome) {
      // Android : lien qui rouvre la même page dans Chrome (repli : la page elle-même) ; ailleurs, pas de lien
      const montrer = c === "integre" && android;
      chrome.hidden = !montrer;
      if (montrer) {
        chrome.href = `intent://${location.host}${location.pathname}${location.search}#Intent;scheme=https;package=com.android.chrome;` +
          `S.browser_fallback_url=${encodeURIComponent(location.href)};end`;
      } else {
        chrome.removeAttribute("href");
      }
    }
    const deja = dlg.querySelector("[data-nx-deja]");
    if (deja) deja.hidden = !(lire("localStorage", CLE_INSTALLEE) && !invite);   // sans doute déjà installée sur ce téléphone
    dlg.querySelectorAll("img").forEach((im) => { im.loading = "eager"; });
    if (dlg.hasAttribute("open")) return;
    if (typeof dlg.showModal === "function") {
      dlg.showModal();
    } else {
      dlg.classList.add("nx-appli-aide--repli");   // navigateur sans <dialog> : fenêtre fixe sans voile
      dlg.setAttribute("open", "");
    }
  };
  function fermerGuide() {
    if (!dlg || !dlg.hasAttribute("open")) return;
    if (typeof dlg.close === "function") dlg.close();
    else { dlg.removeAttribute("open"); dlg.classList.remove("nx-appli-aide--repli"); }
  }
  if (dlg) {
    dlg.addEventListener("click", (e) => {
      if (e.target.closest("[data-nx-fermer-guide]") || e.target === dlg) fermerGuide();   // bouton ou clic sur le voile
    });
  }

  const installer = async () => {
    if (enCours) return;   // double appui : une seule fenêtre
    enCours = true;
    try {
      if (invite) {
        const e = invite;
        invite = window.NX_INVITE = null;   // une fenêtre « Installer » ne sert qu'une fois
        try {
          await e.prompt();
          const choix = await e.userChoice;
          fermerCarte();
          if (!choix || choix.outcome !== "accepted") ecrire("localStorage", CLE_REFUS, String(Date.now()));
        } catch (_) {
          ouvrirGuide();
        }
      } else {
        ouvrirGuide();
      }
    } finally {
      enCours = false;
    }
  };
  D.addEventListener("click", (e) => {
    if (!e.target.closest) return;
    if (e.target.closest("[data-nx-installer]")) { e.preventDefault(); installer(); }
    else if (e.target.closest("[data-nx-plus-tard]")) { ecrire("localStorage", CLE_PLUS_TARD, String(Date.now())); fermerCarte(); }
  });

  /* ------------------------------------------------------------ carte d'invitation (téléphone) */
  function fermerCarte() {
    if (!carte) return;
    carte.hidden = true;
  }
  // panier : Shopify garde son contenu dans le compteur de l'icône (Dawn) ; dans un navigateur intégré, il ne suivrait pas
  const panierPlein = () => { const b = D.querySelector(".cart-count-bubble"); return !!(b && /\d/.test(b.textContent) && !/^\s*0\s*$/.test(b.textContent)); };
  // menu ou recherche de Dawn ouverts : ils ajoutent une classe « overflow-hidden… » au corps de la page
  const recouvert = () => Array.prototype.some.call(D.body.classList, (c) => c.indexOf("overflow-hidden") === 0);
  const carteVoulue = () => telephone() && (parLien || !lire("localStorage", CLE_INSTALLEE)) && !recent(CLE_PLUS_TARD, 7) && !recent(CLE_REFUS, 3) &&
    !(integre && panierPlein());
  const montrerCarte = () => {
    if (!carte || !carteVoulue()) return;   // tout est revérifié au moment de montrer
    if (recouvert()) { planifierCarte(3000); return; }
    carte.hidden = false;
  };
  const typePage = zone ? zone.getAttribute("data-page") : "";
  const pageOk = ["index", "collection", "list-collections", "search", "page", "blog", "article", "policy"].includes(typePage) ||
    (parLien && !["product", "cart"].includes(typePage));
  // une seule carte prévue à la fois ; rappelée aussi quand le navigateur propose l'installation après coup
  function planifierCarte(delai) {
    if (minuteur || !carte || !carte.hidden || !pageOk || !carteVoulue()) return;
    const im = carte.querySelector("img");
    if (im) im.loading = "eager";   // l'icône est prête quand la carte apparaît
    minuteur = setTimeout(() => { minuteur = 0; montrerCarte(); }, delai);
  }
  const vues = (Number(lire("sessionStorage", CLE_VUES)) || 0) + 1;
  ecrire("sessionStorage", CLE_VUES, String(vues));
  planifierCarte(parLien ? 800 : vues >= 2 ? 1500 : 8000);
})();
